import { render, staticRenderFns } from "./cancel-appointment.vue?vue&type=template&id=b5beb014"
import script from "./cancel-appointment.vue?vue&type=script&lang=js"
export * from "./cancel-appointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports